<div class="columns no-pad-left no-pad-right">

  @if (paginationData.totalPages > 1) {
    <nav class="vf-pagination" aria-label="Pagination" >
      <ul class="vf-pagination__list">
        <li class="vf-pagination__item vf-pagination__item--previous-page">
          <a href="JavaScript:void(0);" class="vf-pagination__link" (click)="paginateTo(-1, 'arrow')"
            [ngClass]="paginationData.currentPage === 1 ? 'vf-pagination__link--disabled' : ''">
            Previous
          </a>
        </li>
        @for (pgi of paginationData.pages; track pgi; let pageRecIndex = $index) {
          <li class="vf-pagination__item"
            [ngClass]="pgi == paginationData.currentPage? 'vf-pagination__item--is-active' : ''">
            @if (pgi !== -1 && pgi !== paginationData.currentPage) {
              <a href="JavaScript:void(0);"
                class="vf-pagination__link"
                (click)="paginateTo(pgi, 'btn')">
                {{pgi}}
              </a>
            }
            @if (pgi !== -1 && pgi === paginationData.currentPage) {
              <span class="vf-pagination__label" aria-current="page" >
                {{pgi}}
              </span>
            }
            @if (pgi === -1) {
              <span><strong>...</strong></span>
            }
          </li>
        }
        <li class="vf-pagination__item vf-pagination__item--next-page">
          <a href="JavaScript:void(0);" class="vf-pagination__link" (click)="paginateTo(1, 'arrow')"
            [ngClass]="paginationData.currentPage === paginationData.totalPages ? 'vf-pagination__link--disabled' : ''">
            Next
          </a>
        </li>
      </ul>
    </nav>
  }

</div>